import { SearchBar } from '@ui/common/search-bar.tsx';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect } from 'react';
import { AllProducts, MainPromotion, PopularProducts } from '@features/main';
import { useNavigate } from 'react-router-dom';
import { MainPopularCategories } from '@features/main/main-popular-categories.tsx';
import { Line } from '@ui/common/line.tsx';
import { Link } from '@heroui/react';
import { LazyImage } from '@ui/common/lazy-image.tsx';

export const MainPage = () => {
  const set = useNavbar();
  const navigate = useNavigate();

  useEffect(() => {
    set.main();
  }, []);

  return (
    <>
      <MainPromotion />

      <div className="lg:hidden">
        <SearchBar onPress={() => navigate('/search')} isEditable={false} />
      </div>

      <MainPopularCategories />

      <Line />

      <div className="container max-w-7xl lg:mx-auto lg:pb-12">
        <PopularProducts />
      </div>

      <Line />

      <div className="container max-w-7xl lg:mx-auto lg:pb-12">
        <AllProducts />
      </div>

      <Line isDesktop />

      <div className="bg-[#F0F4FD] py-[54px] px-12 rounded-2xl container max-w-7xl mx-auto relative my-24 hidden lg:block">
        <h3 className="text-[#222222] text-4xl font-bold max-w-[660px]">
          Установи мобильное приложение
        </h3>
        <p className="text-[#60656C] text-lg max-w-[660px] mt-4">
          Покупайте ещё быстрее — через наше приложение Сканируйте чек,
          сохраняйте рецепты и получайте уведомления о скидках!
        </p>
        <div className="flex flex-row items-center gap-x-6 mt-12">
          <Link
            target="_blank"
            href="https://play.google.com/store/apps/details?id=kz.zerder_pharma.zerde"
            className="w-40 h-12"
          >
            <LazyImage src="/google_play_button.png" />
          </Link>

          <Link href="/" className="w-[142px] h-12">
            <LazyImage src="/app_store_button.png" />
          </Link>
        </div>

        <div className="w-[310px] h-[380px] absolute -top-8 right-24">
          <LazyImage src="/mock_phones.png" />
        </div>
      </div>
    </>
  );
};
